import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {BaseEntityService} from './base-entity.service';
import {IUserVacationRequest} from '../../model/type/vacation-user-request.model';
import {map} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserVacationRequestService extends BaseEntityService<IUserVacationRequest, number>{
    constructor(protected override http: HttpClient) {
        super('user_vacation_request', http);
    }

    findAllByUserId(userId: number | undefined) {
        return this.http.get<any>(`${this.resourceUrl}/all/${userId}`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    findTopByUserId(userId: number | undefined) {
        return this.http.get<any>(`${this.resourceUrl}/top/${userId}`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    findAllPending() {
        return this.http.get<any>(`${this.resourceUrl}/all/pending`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }
    
    cancel(data: IUserVacationRequest) {
        return this.http.put<any>(`${this.resourceUrl}/cancel`, data, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }
}
